import { Avatar, Typography, TypographyProps } from '@mui/material';
import { School } from '@schooly/api';
import React, { FC } from 'react';

import { SchoolAvatar } from './SchoolAvatar';
import { SchoolSelectItemStyled } from './SchoolSelect.styled';

export interface SchoolSelectItemProps {
  school: School;
  subitem?: boolean;
  hideName?: boolean;
  color?: TypographyProps['color'];
  onClick?: React.MouseEventHandler;
}

const SCHOOL_AVATAR_SIZE = 36;
const SCHOOL_SUBITEM_AVATAR_SIZE = 30;

export const SchoolSelectItem: FC<SchoolSelectItemProps> = ({
  school,
  subitem,
  color,
  onClick,
  hideName,
}) => {
  const size = subitem ? SCHOOL_SUBITEM_AVATAR_SIZE : SCHOOL_AVATAR_SIZE;

  return (
    <SchoolSelectItemStyled onClick={onClick} subitem={subitem}>
      {school?.image ? (
        <Avatar sx={{ bgcolor: 'background.paper', width: size, height: size }}>
          <SchoolAvatar school={school} />
        </Avatar>
      ) : (
        <Avatar
          sx={{
            width: size,
            height: size,
            bgcolor: 'background.default',
            border: (theme) => theme.mixins.borderValue(),
          }}
        >
          <Typography color="common.grey3">{school?.code}</Typography>
        </Avatar>
      )}
      {!hideName && (
        <Typography
          variant={subitem ? 'h3' : 'h2'}
          color={color ?? 'inherit'}
          sx={{
            whiteSpace: 'normal',
            alignSelf: 'center',
          }}
        >
          {subitem ? school?.name : school?.code}
        </Typography>
      )}
    </SchoolSelectItemStyled>
  );
};
